<template>
  <div>
      <yetkidialog ref="yetkidialog"></yetkidialog>
      <hatadialog ref="hatadialog"></hatadialog>
      <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
      <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>
      
      <v-dialog v-model="altgrupsatisfiyatdialog" persistent max-width="400">
        <v-card>
          <v-card-title class="headline">Fiyat</v-card-title>
          <v-card-text>
            <v-layout row="" wrap>
                            <v-flex xs12 sm12 md12>
                            
                              <sayiinput  v-model="selectedaltfiyatgrup.SatisFiyat.TekKisiFiyati"  :autocomplete="'autocomplete'"  etiket="Tek Kişi Fiyat"></sayiinput>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                            
                            <sayiinput  v-model="selectedaltfiyatgrup.SatisFiyat.IkinciKisideTekKisiFiyati"  :autocomplete="'autocomplete'"  etiket="İkinci Kişide Tek Kişi"></sayiinput>
                         
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            
                            <sayiinput  v-model="selectedaltfiyatgrup.SatisFiyat.UcuncuKisiFiyati"  :autocomplete="'autocomplete'"  etiket="Üçüncü Kişi Fiyatı"></sayiinput>
                         
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            
                            <sayiinput  v-model="selectedaltfiyatgrup.SatisFiyat.CocukFiyati"  :autocomplete="'autocomplete'"  etiket="Çocuk Fiyatı"></sayiinput>
                         
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            
                            <sayiinput  v-model="selectedaltfiyatgrup.SatisFiyat.BebekFiyati"  :autocomplete="'autocomplete'"  etiket="Bebek Fiyatı"></sayiinput>
                         
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            
                            <v-select
                  hide-details
                  v-model="selectedaltfiyatgrup.SatisFiyat.ParaBirimi"
                  :items="dovizItems"
                  :rules="[(v) => !!v || $t('Mandatory-section')]"
                  item-text="Title"
                  item-value="DovizKod"
                  :label="$t('Currency-Unit')"
                ></v-select>
                         
                          </v-flex>
                          <!-- <v-flex xs12 sm12 md12>
                            
                            <sayiinput  v-model="selectedaltfiyatgrup.SatisFiyat.Kur"  :autocomplete="'autocomplete'"  etiket="Kur"></sayiinput>
                         
                          </v-flex> -->
                          </v-layout>
                         

         
          
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat  @click.native="altgrupsatisfiyatdialog = false" >Kapat</v-btn>
           
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="fiyatAltgrupdialog" persistent max-width="400">
        <v-card>
          <v-card-title class="headline">Fiyat Alt Grubu</v-card-title>
          <v-card-text>
            <v-layout>
                            <v-flex xs12 sm12 md12>
                              <v-select
                          label="Fiyat Alt Grubu"
                          item-text="Aciklama"
                          item-value="Id"
                          :items="fiyatAltGruplar"
                          v-model="fiyatAltGrup"
                          return-object
                        ></v-select>
                            </v-flex>
                           
                          </v-layout>
                         

         
          
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat  @click.native="fiyatAltgrupdialog = false" >İptal</v-btn>
            <v-btn color="primary" flat @click="ProgramAltFiyatGrupEkle()"
              >Kaydet</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog v-model="fiyatgrupdialog" persistent max-width="400">
        <v-card>
          <v-card-title class="headline">Fiyat Grubu</v-card-title>
          <v-card-text>
            <v-layout>
                            <v-flex xs12 sm12 md12>
                              <v-select
                          label="Fiyat Ana Grubu"
                          item-text="Aciklama"
                          item-value="Id"
                          :items="fiyatAnaGruplar"
                          v-model="fiyatAnaGrup"
                          return-object
                        ></v-select>
                            </v-flex>
                           
                          </v-layout>
                         

         
          
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat  @click.native="fiyatgrupdialog = false" >İptal</v-btn>
            <v-btn color="primary" flat @click="ProgramFiyatGrupEkle()"
              >Kaydet</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    
  
      <v-card height="100%" color="grey lighten-5" flat>
          <v-form>
              <v-layout row wrap>
                  <v-flex xs12 sm12>
                      <v-toolbar class="baslik" size="120px" dark color="info">
                          <v-toolbar-title>Tur Alt Paket </v-toolbar-title>
                          <v-spacer></v-spacer>
  
                          <v-tooltip bottom>
        <v-btn :disabled="!sayfayetki.Save" slot="activator" @click="kaydet()" flat> <span
            class="hidden-sm-and-down"> <span class="hidden-sm-and-down"> {{$t('save_button')}} </span>
          </span>
          <v-icon right dark>add_box</v-icon>

        </v-btn>
      
      </v-tooltip>
                            
                        
  
                              
                            
  
                          <v-menu bottom="">
                              <v-btn slot="activator" dark icon>
                                  <v-icon>more_vert</v-icon>
                              </v-btn>
  
                              <v-list>
                                  <a target="_self" v-bind:href="'#/pakettur/turaltpaket/'">
  
                                      <v-list-tile>
                                          <v-list-tile-title>{{$t('cancel_button')}}</v-list-tile-title>
                                      </v-list-tile>
                                  </a>
                              </v-list>
                              
                          </v-menu>
  
                      </v-toolbar>
                  </v-flex>
  
                  <v-tabs style="width:100%;" dark=""  color="blue darken-3" slot="extension" slider->
                      <v-tabs-slider></v-tabs-slider>
                      <v-tab href='#0'>
                          {{$t("tab_general")}}
                      </v-tab>
                      <v-tab-item :id="'0'" style="width:100%; height:500px;">
                          <v-layout row="" wrap="">
                              <v-flex pa-1 xs12 sm6 md6>
                                  <v-card class="white--text">
                                      <v-card flat="">
                                          <v-card-actions>
                                              <v-layout row wrap>
                                                  <v-flex xs9 md3 sm9>
                                                  <v-text-field label="Kod"  maxlength="50"  hide-details="" v-model="turKodu"  >
                                                   
                                                  </v-text-field>

                                              </v-flex>
                                              <v-flex xs9 md7 sm8>
                                                  <v-text-field label="Adı"  maxlength="250"  hide-details="" v-model="turAdi"  >
                                                   
                                                  </v-text-field>

                                              </v-flex>
                                              <v-flex xs9 md2 sm8>
                                                  <v-checkbox label="Aktif" v-model="turAktif"></v-checkbox>

                                              </v-flex>
                                              <v-flex xs9 md6 sm12>
                                                      <v-select
                          label="Kategori"
                          item-text="Aciklama"
                          item-value="Id"
                          :items="kategoriler"
                          v-model="turKategoriID"
                          
                        ></v-select>

                                              </v-flex>
                                              <v-flex xs9 md6 sm12>
                                                  <v-select
                          label="Ürün Grubu"
                          item-text="Aciklama"
                          item-value="Id"
                          :items="urungruplari"
                           v-model="turUrunGrupID"
                          
                        ></v-select>

                                              </v-flex>
                                              <v-flex xs9 md4 sm8>
                                                  <v-text-field label="Gündüz"  maxlength="15"  hide-details="" v-model="turGunduz" type="number" >
                                                   
                                                  </v-text-field>

                                              </v-flex>
                                              <v-flex xs9 md4 sm8>
                                                  <v-text-field label="Gece"  maxlength="15"  hide-details="" v-model="turGece" type="number"  required>
                                                   
                                                  </v-text-field>

                                              </v-flex>
                                              <v-flex xs9 md4 sm8>
                                                  <v-text-field label="Kontenjan"  maxlength="15"  hide-details="" v-model="turKontenjan" type="number"  required>
                                                   
                                                  </v-text-field>

                                              </v-flex>
                                              </v-layout>
                                             
                                          </v-card-actions>
                                      </v-card>
                                  </v-card>
                                
                              </v-flex>
                              <v-flex pa-1 xs12 sm6 md6>
                                  <v-card class="white--text">
                                      <v-card flat="">
                                          <v-card-actions>
                                              <v-layout row wrap>
                                                  <v-flex xs9 md12 sm12>
                                                    <v-autocomplete
                                                    label="Başlangıç Noktası"
                          item-text="Title"
                          item-value="ParkurKod"
                          :items="Parkurs"
></v-autocomplete>
                                                    

                                              </v-flex>
                                              <v-flex xs9 md6 sm12>
                                                <v-autocomplete
                                                label="Varış Parkur"
                          item-text="Title"
                          item-value="ParkurKod"
                          :items="Parkurs"
></v-autocomplete>
                                                 </v-flex>
                        <v-flex xs9 md6 sm12>
                          <v-autocomplete
                          label="Dönüş Parkur"
                          item-text="Title"
                          item-value="ParkurKod"
                          :items="Parkurs"
></v-autocomplete>
                                                 
                                              </v-flex>
                                              <v-flex xs9 md12 sm12>
                                                  <v-textarea
                           v-model="turNotlar"
                            :label="$t('Notes')"
                          ></v-textarea>
                                              </v-flex>
                                              </v-layout>
  
                                          </v-card-actions>
                                      </v-card>
                                  </v-card>
                              </v-flex>
                             
                          </v-layout>
                         
                        
                      </v-tab-item>
  
                      <v-tab href='#1' ripple>
                          {{ 'Resimler' }}
                      </v-tab>
  
                      <v-tab-item :id="'1'" style="width:100%; height:100%;">
                          <v-layout row wrap>
                              <v-container fluid>
          <v-card color="grey lighten-5">
            <v-layout row wrap>
              <v-flex xs12 sm6 md2>
                <v-layout align-center justify-start row fill-height>
                  <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data"
                   lazy-validation>
                    <input hidden type="file" id="files" ref="files" multiple  />
                  </v-form>
                  <v-btn :loading="false" :disabled="false" color="info" dark >
                    <v-icon color="white" left>attach_file</v-icon> {{ 'Eklenecek Resim Dosyası Seçin' }}
                  </v-btn>

                 



                

                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md4>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-alert :value="true"  icon="check_circle" outline>
                
                </v-alert>
              </v-flex>
            </v-layout>
          </v-card>
        </v-container>
                        

                          </v-layout>
                          <v-layout row="" wrap="">
                          <v-container fluid>

                              <v-layout row="" wrap="">
                         
                         
                              <v-flex pa-1 xs12 sm6 md3>
                                  <v-card >
                                      <v-card-text >
                                          <v-img 
            class="bg-grey-lighten-2 w-100"
          
            src="https://picsum.photos/350/165?random"
          ></v-img>
                                      </v-card-text>
       
                                      <v-card-actions >
                                          <v-spacer></v-spacer>
              <v-btn flat icon color="">
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn flat icon color="">
            <v-icon>star</v-icon>
          </v-btn>
          </v-card-actions>
        </v-card>
  
                              </v-flex>
                              <v-flex pa-1 xs12 sm6 md3>
                                  <v-card>
                                      <v-card-text>
                                          <v-img
            class="bg-grey-lighten-2  w-100"
            
            src="https://picsum.photos/350/165?random"
          ></v-img>
                                      </v-card-text>
       
                                      <v-card-actions >
                                          <v-spacer></v-spacer>
              <v-btn flat icon color="">
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn flat icon color="">
            <v-icon>star</v-icon>
          </v-btn>
          </v-card-actions>
        </v-card>
  
                              </v-flex>
                              <v-flex pa-1 xs12 sm6 md3>
                                  <v-card>
                                      <v-card-text>
                                          <v-img
                                          
            class="bg-grey-lighten-2  w-100"
           
            src="https://picsum.photos/350/165?random"
          ></v-img>
                                      </v-card-text>
       
          <v-card-actions class="text-h6">
           
              <v-btn flat icon color="">
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn flat icon color="">
            <v-icon>star</v-icon>
          </v-btn>
          </v-card-actions>
        </v-card>
  
                              </v-flex>
                              <v-flex pa-1 xs12 sm6 md3>
                                  <v-card>
                                      <v-card-text>
                                          <v-img
                                          
            class="bg-grey-lighten-2  w-100"
            
            src="https://picsum.photos/350/165?random"
          ></v-img>
                                      </v-card-text>
       
          <v-card-actions class="text-h6">
             
              <v-btn flat icon color="">
            <v-icon>delete</v-icon>
          </v-btn>
          <v-btn flat icon color="blue">
            <v-icon>star</v-icon>
          </v-btn>
          </v-card-actions>
        </v-card>
  
                              </v-flex>
                          </v-layout>
                          </v-container>
                          </v-layout>
                   
                      </v-tab-item>
  
                      <v-tab href='#2' ripple>
                          {{ $t('Program') }}
                      </v-tab>
  
                      <v-tab-item :id="'2'" class="pa-2">
                        <v-layout row="" wrap="">
                          <v-flex pa-2 xs12 sm6 md6>
                          <v-card class="white--text pa-2">
                           
                            <v-select 
                         label="Fiyat Grubu"
                         item-text="FiyatGrubu.isim"
                         item-value="FiyatGrubu.id"
                          :items="Programlar.FiyatGruplari"
                           v-model="selectedfiyatgrup"
                           return-object
                         >
                         <template #append>
                             <v-icon right color="info" @click="ProgramFiyatGrupDialog()">add_box</v-icon>
                           </template>
                         </v-select>
                         <v-layout row="" wrap="">
<v-select 
label="Alt Fiyat Grubu"
                          item-text="AltGrup.isim"
                          item-value="AltGrup.id"
                          :items="selectedfiyatgrup.AltGruplar"
                       v-model="selectedaltfiyatgrup"
                       return-object
>
<template #append>
 
    <v-icon right color="info" @click="ProgramAltFiyatGrupDialog()">add_box</v-icon>
  
</template>
</v-select>


                        </v-layout>
                        <v-layout row="" wrap="">
                          
                          <tarihim :etiket="$t('Date')" 
                              v-model="eklenecektarih"
                             ></tarihim>


                              <v-select 
label="İş Tipi"
                          item-text="ad"
                          item-value="id"
                          :items="PaketIsTipleri"
                       v-model="eklenecekistipi"
                       return-object
>
<template #append>
  <v-btn color="info" @click="ProgramIsEkle()">Ekle
  <v-icon right dark>play_arrow</v-icon>
  </v-btn>
</template>
</v-select>

</v-layout>

                          </v-card>
                        </v-flex>
                        <v-flex pa-2 xs12 sm6 md6>
                            <v-layout row="" wrap="">
                              <v-card class="white--text">
                                <v-data-table :headers="headersprogramisler"  :loading="progress" :items="selectedaltfiyatgrup.Tarihler"
:hide-default-footer="true">
<v-progress-linear slot="progress" indeterminate></v-progress-linear>

<template slot="items" slot-scope="props">
<tr item>
<td  class="text-left font-weight-black">
{{ props.item.Tarih | dateformat }}
</td>
<td  class="text-left font-weight-black">
<div v-for="index2 in props.item.Isler">
{{ index2.isim}} </br>
</div>

</td>
</tr>

</template>

</v-data-table>

                              </v-card>
                            </v-layout>
                          </v-flex>

                        </v-layout>
                       
                      </v-tab-item>
                         
                           
                             

                             
                             
                       
                        
                       
                              
                        



                       
                       
                       
                       
                      
                       
                      
                       
                     
  
                      <v-tab href='#3' ripple>
                          {{$t('Price')}}
                      </v-tab>
  
                      <v-tab-item :id="'3'">
  
                          <v-layout row="" wrap>
                              
                             
                              <v-flex  xs12
        sm12
        md12
        lg12 pa-2>
        <v-card>
          <v-card-title>
            <p class="font-weight-black">Alt Paket Fiyatlar</p> 
                                      <v-spacer></v-spacer>

                                      <v-select 
                         label="Fiyat Grubu"
                         item-text="FiyatGrubu.isim"
                         item-value="FiyatGrubu.id"
                          :items="Programlar.FiyatGruplari"
                           v-model="selectedfiyatgrup"
                           return-object
                         ></v-select>
                                  </v-card-title>
                                  <v-divider></v-divider>
                                  <v-card-text>
                                      <v-data-table :headers="headersfiyatalt"  :loading="progress" :items="selectedfiyatgrup.AltGruplar"
        :hide-default-footer="true">
      <v-progress-linear slot="progress" indeterminate></v-progress-linear>

      <template slot="items" slot-scope="props">
        <tr  item>
          <td class="text-xs-left">{{ props.item.AltGrup.isim }}</td>
          <td class="text-xs-left">{{ props.item.SatisFiyat.TekKisiFiyati }}</td>
          <td class="text-xs-left">{{ props.item.SatisFiyat.IkinciKisideTekKisiFiyati }}</td>
          <td class="text-xs-left">{{ props.item.SatisFiyat.UcuncuKisiFiyati }}</td>
          <td class="text-xs-left">{{ props.item.SatisFiyat.CocukFiyati }}</td>
          <td class="text-xs-left">{{ props.item.SatisFiyat.BebekFiyati }}</td>
          <td class="text-xs-left">{{ props.item.SatisFiyat.ParaBirimi }}</td>
          <td class="justify-center align-center full-heigth layout px-0">
            <v-btn @click="altgrupfiyatguncelledialog(props.item.AltGrup.isim)" icon small flat>
              <v-icon color="info">edit</v-icon>
            </v-btn>
          
          </td>
          <!-- <td class="text-xs-left">{{ props.item.SatisFiyat.Kur }}</td> -->
         
         
        </tr>
      </template>
     
    </v-data-table>
                                  </v-card-text>
                              </v-card>
                              </v-flex>
                          </v-layout>
                      </v-tab-item>
  
                    
  
                  </v-tabs>
  
                  
              
  
  
               
  
              </v-layout>
          </v-form>
  
      </v-card>
  </div>
  </template>
  
  <script>
  import auth from '../../../api/auth'
  import parainput from '../customcomp/parainput'
  import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
  import tarihim from "@/components/app/customcomp/tarihim.vue"
  import tool from "../coper/tools";
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import cariaracomp from '@/components/app/customcomp/cariaracomp'
  import analizcomp from '@/components/app/bilet/partpage/analizcomp'
  import loadingcomp from "@/components/app/customcomp/loadingcomp"
  import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp'
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  import sayiinput from '@/components/app/customcomp/sayiinput.vue';
  export default {
      data() {
          return {
            altgrupsatisfiyatdialog:false,
            selectedfiyatgrup:{
              AltGruplar:[]
            },
            selectedaltfiyatgrup:{
              Tarihler:[],
              SatisFiyat:{
              TekKisiFiyati: 0.0,
              IkinciKisideTekKisiFiyati: 0.0,
              UcuncuKisiFiyati: 0.0,
              CocukFiyati: 0.0,
              BebekFiyati: 0.0,
              ParaBirimi: "",
              Kur: 0.0
            },

            },
            fiyatgrupdialog:false,
            fiyatAltgrupdialog:false,
            dovizItems: [],
  


    eklenecekistipi:null,
    eklenecektarih:null,

  

            PaketIsTipleri:[
              {
                ad:'Ucus',
                id:1
              },
              {
                ad:'GelisTransferi',
                id:2
              },
              {
                ad:'GidisTransferi',
                id:3
              },
              {
                ad:'Tasima',
                id:4
              },
              {
                ad:'Otel',
                id:5
              },
              {
                ad:'Restaurant',
                id:6
              },
              {
                ad:'Rehber',
                id:7
              },
              {
                ad:'ArabaKiralama',
                id:8
              },
              {
                ad:'Muze',
                id:9
              },
              {
                ad:'Diger',
                id:10
              },
              {
                ad:'GunlukSehirTuru',
                id:11
              },
              {
                ad:'TamGunBosAyak',
                id:12
              },
              {
                ad:'YarimGunBosAyak',
                id:13
              },
              {
                ad:'Gemi',
                id:14
              },
            ],
            Programlar:{
              FiyatGruplari:[],
            },
            snackbar:false,
            progress:false,
            credentials :null,
            Parkurs:[],
           
    
    fiyatAnaGruplar:[],
    fiyatAltGruplar:[],
    kategoriler:[],
    urungruplari:[],
    headersprogramisler:[
    {
 text: 'Tarih',
          value: 'Tarih'
},
        {
 text: 'İş Tipi',
          value: 'isim'
},
      
    ],
  
    headersfiyatalt: [
    {
          text: 'Alt Grup',
          
        },
      {
          text: 'Tek Kişi',
          value: 'TekKisiFiyati'
        },
        {
          text: 'İkinci Kişide Tek Kişi',
          value: 'IkinciKisideTekKisiFiyati'
        },
        {
          text: 'Üçüncü Kişi ',
          value: 'UcuncuKisiFiyati'
        },
      
        {
          text: 'Çocuk',
          value: 'CocukFiyati'
        },
        {
          text: 'Bebek',
          value: 'BebekFiyati'
        },
        {
          text: 'PB',
          value: 'ParaBirimi'
        },
        // {
        //   text: 'Kur',
        //   value: 'Kur'
        // },
        {
          text: 'Güncelle',
          
        },
      ],
    
    
     
              PB:"TRY",
            
              tumsirketler:false,
              currentCheck:{},
              sablonSelectedItem:{
                  design:[]
              },
              sablonData:null,
              itemsSablon:[],
              itemsSablonSelected:[],
              counter: 0,
              loadingvmodel: false,
              videodialog: false,
              sayfayetki: {
                  Screen: true,
                  Update: true,
                  Save: true,
                  Delete: true,
                  Status: true,
                  Message: null,
                  islem: 0,
              },
  
              prevRoute: null,
  
              mukellefScroll: false,
              hesapgurubu: [],
              dialogfiltre: false,
              cokluposta: false,
              postaitems: [],
              valid: true,
              tabcontrol3: 0,
              drawer: null,
              baslik: '',
              e1: 0,
              Code: '',
              e2: true,
              yok: false,
              statecari: [],
              search: '',
              search1: '',
              loading: false,
             
           
             
  
   
             
  
             
  
              dictionary: {
                  custom: {
                      carikod: {
                          required: () => this.$t('This-space-cannot-left-blank'),
                      },
                      unvan: {
                          required: () => this.$t('This-space-cannot-left-blank'),
                      },
  
                  }
              },
  
              text1:null,
              MasterTurId:0,
              fiyatAltGrup:null,
              fiyatAnaGrup:null,
              PaketTurIsTarih:null,
              kaydetbuton: false,
              turKategoriID:null,
              turUrunGrupID:null,
              turAdi:null,
              turKodu:null,
              turGece:null,
              turGunduz:null,
              turAktif:null,
              turKontenjan:null,
              turId:0,
              turNotlar:null,
              isUpdate:false
          }
      },
      beforeRouteEnter(to, from, next) {
          next(vm => {
              vm.prevRoute = from.path
          })
      },
  
      mounted() {
          this.$validator.localize('en', this.dictionary)
          if (this.$route.query.id >0){
            this.isUpdate=true;
          }
        this.credentials=  JSON.parse(window.localStorage.getItem('credentials'));

        this.getParaBirimleri();
        this.getParkurs(); 
        this.getkategoriler();
        this.geturungruplari();
this.getFiyatAnaGrup();
this.getFiyatAltGrup();

        if (this.isUpdate)
        {
          this.turId=this.$route.query.id;
          this.MasterTurLoad();
        }
      },
      methods: {
        getParaBirimleri()
        {
          var params = {
      CompanyCode: this.credentials.SirketKodu,
    };
    this.$http
      .post(auth.API_URL + "api/currency/List", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      })
      .then(
        (response) => {
          this.dovizItems = response.body;
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable-Döviz";
            this.snackbar = true;
          } else {
            this.text1 = "Service Unavailable-Döviz";
            this.snackbar = true;
          }
        }
      );
        },
        ProgramIsEkle()
        {
          
          let res =this.selectedaltfiyatgrup.Tarihler.find(x => x.Tarih == this.eklenecektarih);
          if (res==null || res=='undefined')
        {
          var tarih= {
                    Tarih: this.eklenecektarih,
                    Isler: [
                      {
                        Id: 0,
                        IsTipi: this.eklenecekistipi.id,
                        isim:this.eklenecekistipi.ad
                      },
                    ],
                  }
                  this.selectedaltfiyatgrup.Tarihler.push(tarih);
        }
        else
        {
          let istipi={ Id: 0,
                        IsTipi: this.eklenecekistipi.id,
                        isim:this.eklenecekistipi.ad

          }
          res.Isler.push(istipi);
        }
         
                   
        },
        altgrupfiyatguncelledialog(altgrupisim)
        {
          let res =this.selectedfiyatgrup.AltGruplar.find(x => x.AltGrup.isim == altgrupisim);
          this.selectedaltfiyatgrup=res;
          this.altgrupsatisfiyatdialog=true;
        },
        ProgramAltFiyatGrupDialog()
        {
          
          this.fiyatAltgrupdialog=true;
        },
        ProgramAltFiyatGrupEkle(){
         
          let res =this.Programlar.FiyatGruplari.find(x => x.FiyatGrubu.isim == this.selectedfiyatgrup.FiyatGrubu.isim);
          
         

            var altg=      {
                Id: 0,
                AltGrup: {
                  id: this.fiyatAltGrup.Id,
                  kod: this.fiyatAltGrup.Aciklama,
                  isim: this.fiyatAltGrup.Aciklama,
                  tip: 0,
                  intField: null,
                  tumSirketler: false,
                  sayfaAdi: null,
                },
                Tarihler: [
                 
                ],
                SatisFiyat: {
                              TekKisiFiyati: 0.0,
                              IkinciKisideTekKisiFiyati: 0.0,
                              UcuncuKisiFiyati: 0.0,
                              CocukFiyati: 0.0,
                              BebekFiyati: 0.0,
                              ParaBirimi: "",
                              Kur: 0.0
                          },
              }
           
res.AltGruplar.push(altg);
this.fiyatAltgrupdialog=false;

this.selectedaltfiyatgrup=altg;
        },
        ProgramFiyatGrupDialog()
        {
          
          this.fiyatgrupdialog=true;
        },
        ProgramFiyatGrupEkle(){
         
let fgrup = { 
            Id: 0, 
          FiyatGrubu: {
                      id: this.fiyatAnaGrup.Id,
                      kod: this.fiyatAnaGrup.Ad,
                      isim: this.fiyatAnaGrup.Aciklama,
                      tip: 0,
                      intField: null,
                      tumSirketler: false,
                      sayfaAdi: null
                  },
                  AltGruplar: [
                 


                  ]

          };

        
          this.Programlar.FiyatGruplari.push(fgrup);
          this.fiyatgrupdialog=false;
          this.selectedfiyatgrup=fgrup;
        },
        MasterTurLoad() {
    //Örnek Request
    let params = {
      Id: this.turId,
      tumSirketler: false,
      sayfaAdi: null,
    };
    tool.http_post(this, "PaketLoad", params).then(
      (response) => {
        if (response.body.Status == true) {
          this.MasterTurId=response.body.data.MasterTurId;
         this.turAdi=response.body.data.TurAdi;
         this.turKodu=response.body.data.TurKodu;
         this.turNotlar=response.body.data.Notlar;
         this.turGece=response.body.data.Gece;
         this.turGunduz=response.body.data.Gunduz;
         this.turAktif=response.body.data.Aktif;
         this.turKategoriID=parseInt(response.body.data.Kategori.id);
         this.turUrunGrupID=parseInt(response.body.data.UrunGrubu.id);
         this.turKontenjan=response.body.data.Kontenjan;
         this.Programlar=response.body.data.Program;
         
         if (response.body.data.Program.FiyatGruplari.length>0)
         {
         
           this.selectedfiyatgrup=response.body.data.Program.FiyatGruplari[0];
           if (this.selectedfiyatgrup.AltGruplar.length>0)
           {
            this.selectedfiyatgrup.AltGruplar.forEach((valueis,indexis)=>{
              valueis.Tarihler.forEach((valuetarih,indextarih)=>{
                     
                valuetarih.Isler.forEach((valueis,indexis)=>{
                  
                    let res =this.PaketIsTipleri.find(x => x.id == valueis.IsTipi);
                   
                     valueis.isim=res.ad;
                }) 
                    }) 
            
          })
            this.selectedaltfiyatgrup=this.selectedfiyatgrup.AltGruplar[0];
            if (this.selectedaltfiyatgrup.Tarihler.length>0)
           {
            
           }
           }
          
         }
         
        
        } else {
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true;
        }
      },
      (response) => {
        this.text1 = "Hata Oluştu, tekrar deneyiniz";
        this.snackbar = true;
      }
    );
  },

     kaydet()
     {
     
      var prmprogramlar={
              FiyatGruplari:[],
            };

      this.Programlar.FiyatGruplari.forEach((value, index) => {
        var grup={Id:value.Id,FiyatGrubuId:value.FiyatGrubu.id,silinecek:"false",AltGruplar:[]};
        value.AltGruplar.forEach((valuealt,indexalt)=>{
          var altgrup={Id:valuealt.Id,AltGrupId:valuealt.AltGrup.id,Tarihler:[]};
          valuealt.Tarihler.forEach((valuetarih,indextarih)=>{
            var tarihprm={Tarih:valuetarih.Tarih,Isler:[]};
            valuetarih.Isler.forEach((valueis,indexis)=>{
             tarihprm.Isler.push ({Id:valueis.Id,IsTipi:valueis.IsTipi,silinecek:"false"});
          })
            altgrup.Tarihler.push(tarihprm);

          })

          grup.AltGruplar.push(altgrup);
        }
      
      )
        prmprogramlar.FiyatGruplari.push( grup );
});

      let params = {
        MasterTurId:this.MasterTurId,
      Id:this.turId,
      TurKodu: this.turKodu,
      TurAdi: this.turAdi,
      Notlar: this.turNotlar,
      Gece: this.turGece,
      Gunduz: this.turGunduz,
      Aktif: this.turAktif,
      KategoriId: this.turKategoriID,
      UrunGrubuId: this.turUrunGrupID,
      Kontenjan: this.turKontenjan,
      Program:prmprogramlar,
    };
    
    var api="PaketInsert";
    if (this.isUpdate)
    {
      api="PaketEdit"
    }
    tool.http_post(this, api, params).then(
      (response) => {
        if (response.body.Status == true) {
          this.text1 = 'Kayıt Başarılı';
          this.snackbar = true;
         
          var url = '#/pakettur/masterpaket';
          setTimeout(() => {  window.open(url, '_self') }, 1000)
         
        } else {
          this.text1 = response.body.ErrorList[0];
          this.snackbar = true;
        }
      },
      (response) => {
        this.text1 = "Hata Oluştu, tekrar deneyiniz";
        this.snackbar = true;
      }
    );

     },
          HataYonetimi(response, request, baslik) {
              this.mukellefScroll = false
              if (response.status === 500) {
                  //Internal Server Error
                  this.$refs.hatadialog.open(response, request, baslik);
              } else {
                  this.text1 = "Service Unavailable -" + baslik;
                  this.snackbar = true;
              }
          },
        
          getparabirimi() {
              return helpers.getparabirimi()
          },
          getFiyatAltGrup()
          {
            let params = {
      TanitimTip: 12,
    };

    tool.http_post(this, "GenelTipTanitimList", params).then(
      (response) => {
        if (response.body.Status == true) {
          this.fiyatAltGruplar = response.body.data;
        
        } else {
          this.text1 = response.body.ErrorList[0];

          this.snackbar = true;
        }
      },

      (response) => {
       this.text1 = $t('Error-Occured-Please-Try-Again')
        this.snackbar = true;
      }
    );
          },
          getFiyatAnaGrup()
          {
            let params = {
      TanitimTip: 11,
    };

    tool.http_post(this, "GenelTipTanitimList", params).then(
      (response) => {
        if (response.body.Status == true) {
          this.fiyatAnaGruplar = response.body.data;
       
        } else {
          this.text1 = response.body.ErrorList[0];

          this.snackbar = true;
        }
      },

      (response) => {
       this.text1 = $t('Error-Occured-Please-Try-Again')
        this.snackbar = true;
      }
    );
          },
          getkategoriler()
          {
            let params = {
      TanitimTip: 9,
    };

    tool.http_post(this, "GenelTipTanitimList", params).then(
      (response) => {
        if (response.body.Status == true) {
         
          this.kategoriler = response.body.data;
        
        } else {
          this.text1 = response.body.ErrorList[0];

          this.snackbar = true;
        }
      },

      (response) => {
       this.text1 = $t('Error-Occured-Please-Try-Again')
        this.snackbar = true;
      }
    );
          },
          getParkurs()
          {
            var params1 = {
        CompanyCode: this.credentials.SirketKodu
      }
      this.classdialog = false
      this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params1, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.Parkurs = response.body
       
      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          

          this.snackbar = true
        } else {
          this.text1 = 'Service Unavailable'
         

          this.snackbar = true
        }
      })
          },
         
          geturungruplari()
          {
            let params = {
      TanitimTip: 10,
    };

    tool.http_post(this, "GenelTipTanitimList", params).then(
      (response) => {
        if (response.body.Status == true) {
          this.urungruplari = response.body.data;
         
        } else {
          this.text1 = response.body.ErrorList[0];

          this.snackbar = true;
        }
      },

      (response) => {
       this.text1 = $t('Error-Occured-Please-Try-Again')
        this.snackbar = true;
      }
    );
          },
        
          getDateNow: getDateNow,
         
      },
      filters: {
  dateformat: function (t) {
  return helpers.dateformat(t);
  }
  },
      beforeMount: beforeMount,
      components: {
          'parainput': parainput,
          yuzdeinput,
          tarihim,
          yetkidialog,
          hatadialog,
          cariaracomp,
          analizcomp,
          loadingcomp,
          muhasebekoducomp,
          snackbarcomp,
          sayiinput
      },
      watch: {
        
      }
  }
  
 
  
  function beforeMount() {
  
  }
  
  function getDateNow() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();
  
      if (dd < 10) {
          dd = '0' + dd
      }
  
      if (mm < 10) {
          mm = '0' + mm
      }
      today = yyyy + '-' + mm + '-' + dd
      return today
  }
  
 
  </script>
  
  <style>
  </style>
  